import { type UseGenerateQuizRequest } from './type';
import { createQuizAiBuildMutation } from './useBuildAiQuiz';

export type UseGenerateSimliarQuizRequest = UseGenerateQuizRequest & {
  question: string;
  category?: string;
  prompt?: string;
};

export const useGenerateSimliarQuiz =
  createQuizAiBuildMutation<UseGenerateSimliarQuizRequest>(
    '/quiz-builder/generate/similar-quiz',
    ({ question, category, prompt, ...rest }) => ({
      ...rest,
      question,
      category,
      prompt,
    }),
    {
      'Content-Type': 'application/json',
    },
  );
